import React, { useState, useEffect } from 'react'
import { formStyle, stepNumberStyle, formTitleStyle, formDesStyle, topUnderlineStyle, typographyStyle, typographySpanStyle, sectionContainer, typographyTitleStyle } from '../../../constant/material_style';
import { Box, Grid, Typography } from '@mui/material';

const ServiceAgreement = ({ currentStep, setCurrentStep, isScrolledToBottom, setIsScrolledToBottom }) => {
	const [scrollEventTriggered, setScrollEventTriggered] = useState(false);

	const handleSubmit = (e) => {
		e.preventDefault(e);
		setCurrentStep(currentStep + 1);
	}

	useEffect(() => {
		const handleScroll = () => {
			const { scrollHeight, clientHeight } = document.documentElement || document.body;
			const scrollPosition = window.scrollY + clientHeight;
			const threshold = scrollHeight - (scrollHeight * 0.1);

			if (currentStep === 2 && scrollPosition >= threshold) {
				setTimeout(() => {
					setIsScrolledToBottom(true);
				}, 2000); 
				setScrollEventTriggered(true);
			}
		};

		if (!scrollEventTriggered) {
			window.addEventListener("scroll", handleScroll);
		}
	  
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	  
	}, [currentStep, scrollEventTriggered]);

	return (
		<form onSubmit={(e) => handleSubmit(e)}>
			<Box style={formStyle}>
				<Grid container alignItems="flex-start" spacing={2} style={{ marginBottom: '20px', overflowY: 'auto' }}>
					<Grid item>
						<Box style={stepNumberStyle}>{currentStep}</Box>
					</Grid>
					<Grid item xs style={{ paddingLeft: '0' }}>
						<Typography style={formTitleStyle}>Service Agreement</Typography>
						<Typography style={formDesStyle}>Terms & Conditions, PDPA</Typography>
					</Grid>
				</Grid>

				{/* per section */}
				<Box style={sectionContainer}>
					<Box style={topUnderlineStyle}>
						<Typography style={formDesStyle}>Service Agreement</Typography>
					</Box>
				</Box>

				<Box style={sectionContainer}>
					{/* 1.0 */}
					<Typography style={typographyTitleStyle}>
						<span style={typographySpanStyle}>1.0</span>
						Parties
					</Typography>
					<Typography style={typographyStyle}>
						<span style={typographySpanStyle}>1.1</span>
						Komune Care Centre Sdn Bhd (Company No.: -202101014451), a company incorporated in Malaysia with its registered office at A-1-2, Block A, Jaya One, Jalan University, 46200, Petaling Jaya, Selangor, Malaysia (the “Provider”) on one part; and
					</Typography>
					<Typography style={typographyStyle}>
						<span style={typographySpanStyle}>1.2</span>
						The party whose name and description as stipulated in Section 2 of Schedule 1 (the “Resident”) of other part; and
					</Typography>
					<Typography style={typographyStyle}>
						<span style={typographySpanStyle}>1.3</span>
						The party whose name and description as stipulated in Section 3 of Schedule 1 (the “Surety”) of other part.
					</Typography>
					<Typography style={typographyStyle}>
						(The Provider, the Resident and the Surety shall collectively be referred to as the “Parties” and each as “Party”.)
					</Typography>

					{/* 2.0 */}
					<Typography style={typographyTitleStyle}>
						<span style={typographySpanStyle}>2.0</span>
						Services
					</Typography>
					<Typography style={typographyStyle}>
						<span style={typographySpanStyle}>2.1</span>
						In consideration of the payment of the Security Deposit (as defined hereinafter), the Service Fee (as defined hereinafter) and the performance and observation of the terms and conditions of this Agreement by the Resident and the Surety (collectively referred to as the “Customer”), the Provider hereby agrees to provide and the Customer hereby accepts the services as stipulated in Section 4 of Schedule 1 (“Services”) and the license for the Resident to occupy the room as stipulated in Section 5 of Schedule 1 (“Room”) at Komune Living and Wellness, 21, Jalan Tasik Permaisuri 2, Bandar Tun Razak, 56000 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur (“Premises”) upon the terms and subject to the covenants and provisions of this agreement ("this Agreemen t").
					</Typography>
					<Typography style={typographyStyle}>
						<span style={typographySpanStyle}>2.2</span>
						This Agreement shall be valid for a period as stipulated in Section 6 of Schedule 1 (“Term”) commencing from the date as stipulated in Section 7 of Schedule 1 (“Commencement Date”). This Agreement shall be automatically renewed unless otherwise terminated or agreed in writing by the Parties.
					</Typography>

					{/* 3.0 */}
					<Typography style={typographyTitleStyle}>
						<span style={typographySpanStyle}>3.0</span>
						Medical Declaration
					</Typography>
					<Typography style={typographyStyle}>
						The Customer shall declare and provide the medical history and condition of the Resident upon execution of this Agreement. In this regard, the Customer warrants that all information provided by the Customer to the Provider shall be deemed to be the latest, true and accurate information without any omissions by the Customer in assessing the Resident's health condition. For the avoidance of doubt, the Provider shall not be obliged to verify the accuracy of any such information provided by the Customer and the Provider shall not be held liable in any manner and the Customer shall indemnify and keep the Provider indemnified against any losses, damages and liabilities that may arise in the event of any false, inaccurate or non-disclosure of any medical history and/or conditions of the Resident.
					</Typography>

					{/* 4.0 */}
					<Typography style={typographyTitleStyle}>
						<span style={typographySpanStyle}>4.0</span>
						Security Deposit and Service Fee
					</Typography>
					<Typography style={typographyStyle}>
						Security Deposit
					</Typography>
					<Typography style={typographyStyle}>
						<span style={typographySpanStyle}>4.1</span>
						The Customer shall upon the execution of this Agreement pay the Provider a sum as stipulated in Section 8 of Schedule 1 by way of deposit as security for the due observance and performance by the Customer of the terms and conditions of this Agreement (“Security Deposit”).
					</Typography>
					<Typography style={typographyStyle}>
						<span style={typographySpanStyle}>4.2</span>
						The Security Deposit shall not without the prior written consent of the Provider be deemed to be or treated as payment of Service Fee and shall be maintained at all times. If the Service Fee shall at any time hereafter be increased, then the Security Deposit shall be increased proportionately and the Customer shall pay to the Provider of such additional sum as may be necessary.
					</Typography>
					<Typography style={typographyStyle}>
						<span style={typographySpanStyle}>4.3</span>
						The Security Deposit shall be absolutely forfeited by the Provider to pay towards the Penalty (as defined hereinafter) without prejudice to any right of action the Provider may have against the Customer in respect of any unpaid Service Fee or any antecedent breach by the Customer of the terms and conditions herein contained, in the event:-
					</Typography>
					<Typography style={typographyStyle}>
						(a) this Agreement is terminated by the Customer upon the expiry of the first (1st) month of the Term but before the expiration of the Term due to whatsoever reason; and/or
					</Typography>
					<Typography style={typographyStyle}>
						(b) this Agreement is terminated by the Provider as a result of the Customer's default under this Agreement.
					</Typography>
					<Typography style={typographyStyle}>
						<span style={typographySpanStyle}>4.4</span>
						Subject to Clause 4.3 above, the Security Deposit shall be refunded by the Provider to the Customer within fourteen (14) days from the expiry date of this Agreement or the termination date of this Agreement, as the case may be, provided that the Customer shall yield up the Room in accordance with the provisions of this Agreement, free of any interest and subject to such deductions therefrom as the Provider may lawfully make in accordance with the terms and conditions hereof, including but without limiting in any way the rights and remedies of the Provider, any reimbursement of all costs and expenses, losses and damages incurred, expended or suffered or to be incurred, as a result of any breach or default on the part of the Customer of their obligations and liabilities hereunder, and or of such sum or sums which may be due to the Provider and/or incurred by the Provider in the enforcement of its rights and remedies hereunder or in law or in equity.
					</Typography>
					<Typography style={typographyStyle}>
						Service Fee
					</Typography>
					<Typography style={typographyStyle}>
						<span style={typographySpanStyle}>4.5</span>
						The fee structure for the Services is stipulated in Section 1 of Schedule 2 and all fees payable by the Customer shall be collectively referred to as the “Service Fee”. The Service Fee shall be payable in the manner set out in Section 2 of Schedule 2.
					</Typography>
					<Typography style={typographyStyle}>
						<span style={typographySpanStyle}>4.6</span>
						Notwithstanding any provisions to the contrary, the Service Fee shall be subject to fluctuations and variations and the revised amount shall be payable by the Customer upon the expiry of one (1) month's written notice from the Provider. The fluctuations and variations in the Service Fee shall be determined from time to time and at any time by the Provider at the Provider's sole and absolute discretion should there be an increase in costs and the Customer shall not raise any objection of any kind in respect thereof.
					</Typography>
					<Typography style={typographyStyle}>
						<span style={typographySpanStyle}>4.7</span>
						The Customer hereby agrees and authorises the Provider to undertake an appraisal in relation to the needs for the level of care of the Resident as and when deemed necessary by the Provider. As circumstances and the scope of services may change due to the need of the Customer, the Provider may regularly review the Service Fee and discuss with the Customer if any such changes are reasonably required. Where the Provider is required to carry out services which fall outside the agreed scope of services as set out in Section 4 of Schedule 1, the Provider shall obtain the Customer's consent on such additional fees to be incurred for such additional services.
					</Typography>
					<Typography style={typographyStyle}>
						<span style={typographySpanStyle}>4.8</span>
						For the avoidance of doubt, the Customer shall continue to be liable to pay the full Service Fee without discount despite the Resident's non-occupation and/or absent from the Room and/or the Premises for whatsoever period due to whatsoever reason including but not limited to hopitalisation, until and unless this Agreement is lawfully terminated and subject to the Customer yielding up to the Provider the Room in accordance with the provisions of this Agreement.
					</Typography>
					<Typography style={typographyStyle}>
						<span style={typographySpanStyle}>4.9</span>
						All obligations of the Customer in relation to payment including but not limited to Service Fee shall survive the termination of this Agreement.
					</Typography>
					<Typography style={typographyStyle}>
						<span style={typographySpanStyle}>4.10</span>
						The Service Fee and all other monies due and payable by the Customer under this Agreement shall be payable by the Customer to the Provider in advance not later than the seventh (7th) day of each and every month for the entire Term or within five (5) days from the date of receipt of the invoice issued by the Provider, whichever is earlier.
					</Typography>
					<Typography style={typographyStyle}>
						<span style={typographySpanStyle}>4.11</span>
						In the event that the Service Fee or any other payment or charges payable by the Customer under this Agreement is subject to any goods and services tax or any other tax or form of charges payable to the relevant authorities imposed upon by law, the Customer shall notwithstanding anything to the contrary whether in this Agreement or otherwise, pay or reimburse the Provider for such tax or charges.
					</Typography>
					<Typography style={typographyStyle}>
						<span style={typographySpanStyle}>4.12</span>
						The Service Fee for the first month shall be pro-rated accordingly to reflect the number of days from the Commencement Date to the last calendar date of the first month of the Term. In the event of sooner determination of this Agreement prior to the expiry of the Term, the Service Fee for the last month shall be pro-rated to
						reflect the number of days in the last month.
					</Typography>
					<Typography style={typographyStyle}>
						<span style={typographySpanStyle}>4.13</span>
						Without prejudice to the Provider's rights and remedies reserved under this Agreement, in law or at equity, in the event the Service Fee or any part thereof and/or other charges and payments herein covenanted to be paid by the Customer shall remain unpaid after becoming due, the Provider shall be entitled to charge and the Customer shall pay to the Provider the late payment charges calculated on a daily basis at the rate of eight percent (8%) per annum on all moneys due and payable by the Customer to the Provider under this Agreement from the date immediately following the due date until the date of full settlement thereof (“Late Payment Charges”).
					</Typography>

					{/* 5.0 */}
					<Typography style={typographyTitleStyle}>
						<span style={typographySpanStyle}>5.0</span>
						The Surety hereby warrants, covenants and undertakes, inter alia, the following:-
					</Typography>
					<Typography style={typographyStyle}>
						<span style={typographySpanStyle}>5.1</span>
						The Resident hereby warrants, covenants and undertakes, inter alia, the following:-
					</Typography>
					<Typography style={typographyStyle}>
						(a) to respect the rights of others at the Premises;
					</Typography>
					<Typography style={typographyStyle}>
						(b) to respect the needs of the community at the Premises as a whole;
					</Typography>
					<Typography style={typographyStyle}>
						(c) to respect the staff of the Provider;
					</Typography>
					<Typography style={typographyStyle}>
						(d) to care for the Resident’s own health and well-being to the best of the Resident’s ability;
					</Typography>
					<Typography style={typographyStyle}>
						(e) to inform and update the Provider of the Resident’s latest medical and health condition;
					</Typography>
					<Typography style={typographyStyle}>
						(f) to keep the Room and/or the Premises clean and tidy and not to litter or cause any part of the Premises to be unsafe or untidy;
					</Typography>
					<Typography style={typographyStyle}>
						(g) to promptly notify the Provider of any conditions that may cause injury, require repairs, or which affect the habitability of the Room and the Premises;
					</Typography>
					<Typography style={typographyStyle}>
						(h) to strictly adhere to the Rules of Residency (as defined hereinafter);
					</Typography>
					<Typography style={typographyStyle}>
						(i) not to damage or misuse the Room and/or the Premises and/or any part thereof;
					</Typography>
					<Typography style={typographyStyle}>
						(j) not to make any alterations or additions to the Room and/or the Premises;
					</Typography>
					<Typography style={typographyStyle}>
						(k) not to remove any fixtures and fittings of the Provider at the Premises;
					</Typography>
					<Typography style={typographyStyle}>
						(l) not to remove any fixtures and fittings of the Provider at the Room as set out in the list of inventories annexed as Schedule 3 (“Provider’s Fixtures and Fittings”);
					</Typography>
					<Typography style={typographyStyle}>
						(m) not to use the Room and/or the Premises and/or any part thereof in a way that is unlawful or dangerous or which could cause any cancellation, restriction or increase in the insurance premium of Provider;
					</Typography>
					<Typography style={typographyStyle}>
						(n) not to use or store on or near the Room and/or the Premises and/or any part thereof, any flammable, explosive, environmentally hazardous, or other hazardous substance;
					</Typography>
					<Typography style={typographyStyle}>
						(o) not to cause nuisance;
					</Typography>
					<Typography style={typographyStyle}>
						(p) not to allow unauthorized persons to stay over at the Room without the Provider’s prior consent;
					</Typography>
					<Typography style={typographyStyle}>
						(q) not to keep valuables in any form at the Room and/or the Premises and/or any part thereof;
					</Typography>
					<Typography style={typographyStyle}>
						(r) not to give gratuities and/or bribes to the staff of the Provider;
					</Typography>
					<Typography style={typographyStyle}>
						(s) not to engage in any illegal activity, including drug-related and/or illegal gambling activity; and
					</Typography>
					<Typography style={typographyStyle}>
						(t) not conduct or allow any guests of the Resident to conduct themselves, in a loud, boisterous, unruly, or thoughtless manner so as to disturb the rights of others to peace and quiet.
					</Typography>
					<Typography style={typographyStyle}>
						For the avoidance of doubt, the list set out above shall not be deemed exhaustive, and the Resident shall at all times act reasonably in compliance with all the rules determined by the Provider.
					</Typography>
					{/* 6.0 */}
					<Typography style={typographyTitleStyle}>
						<span style={typographySpanStyle}>6.0</span>
						Rules of Residency & Emergency Procedures
					</Typography>
					<Typography style={typographyStyle}>
						Rules of Residency
					</Typography>
					<Typography style={typographyStyle}>
						<span style={typographySpanStyle}>6.1</span>
						The Customer hereby agrees to the rules and regulations set out in the “Rules of Residency” provided to the Customer from time to time. The
					</Typography>
					<Typography style={typographyStyle}>
						<span style={{ display: 'inline-block', marginRight: '6px' }}>12.18</span>
						This Agreement shall be governed by and construed in all respects in accordance with the laws of Malaysia.
					</Typography>
					<Typography style={typographyStyle}>
						*******
					</Typography>
					<Typography style={typographyStyle}>
						(-The rest of this page is intentionally left blank-)
					</Typography>
				</Box>
				<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
					<button type='submit' disabled={!isScrolledToBottom} className={isScrolledToBottom ? 't-accept-button' : 'disabled-btn'}>Next</button>
				</div>
			</Box>
		</form>
	)
}

export default ServiceAgreement